export enum StorageKey {
    CodeVerifier = "nw_code_verifier",
    RefreshToken = "nw_refresh_token",
    AccessToken = "nw_access_token",
    UnitSystem = "nw_unit_system",
    SelectionResolution = "nw_selection_resolution",
    PreRefreshState = "nw_pre_refresh_state",
    WeakDeviceMessageDismissed = "nw_weak_device_message_dismissed",
    IncrementalOfflineLimit = "nw_incremental_offline_limit",
    BimCollabRefreshToken = "BIMcollab_refresh_token",
    BimCollabCodeVerifier = "BIMcollab_code_verifier",
    BimCollabSuggestedSpace = "BIMcollab_suggested_space",
    BimTrackRefreshToken = "BIMtrack_refresh_token",
    BimTrackCodeVerifier = "BIMtrack_code_verifier",
    DitioRefreshToken = "ditio_refresh_token",
    DitioCodeVerifier = "ditio_code_verifier",
    JiraRefreshToken = "jira_refresh_token",
    XsiteManageRefreshToken = "xsitemanage_refresh_token",
    ProcoreMFEOverrides = "system.host.remoteRegistryOverrides",
    MiniMap = "nw_mini_map",
    NavigationCube = "nw_navigation_cube",
    Joysticks = "nw_joysticks",
    UpdateHomeView = "nw_update_home_view",
    AntiAliasing = "nw_anti_aliasing",
    Environment = "nw_environment_url",
    FramerateTarget = "nw_framerate_target",
}

export const storageConfig = {
    [StorageKey.XsiteManageRefreshToken]: {
        storage: localStorage,
    },
    [StorageKey.JiraRefreshToken]: {
        storage: localStorage,
    },
    [StorageKey.BimCollabRefreshToken]: {
        storage: sessionStorage,
    },
    [StorageKey.BimCollabCodeVerifier]: {
        storage: sessionStorage,
    },
    [StorageKey.BimCollabSuggestedSpace]: {
        storage: sessionStorage,
    },
    [StorageKey.BimTrackRefreshToken]: {
        storage: sessionStorage,
    },
    [StorageKey.BimTrackCodeVerifier]: {
        storage: sessionStorage,
    },
    [StorageKey.DitioRefreshToken]: {
        storage: localStorage,
    },
    [StorageKey.DitioCodeVerifier]: {
        storage: sessionStorage,
    },
    [StorageKey.AccessToken]: {
        storage: sessionStorage,
    },
    [StorageKey.RefreshToken]: {
        storage: localStorage,
    },
    [StorageKey.CodeVerifier]: {
        storage: sessionStorage,
    },
    [StorageKey.UnitSystem]: {
        storage: localStorage,
    },
    [StorageKey.SelectionResolution]: {
        storage: localStorage,
    },
    [StorageKey.WeakDeviceMessageDismissed]: {
        storage: localStorage,
    },
    [StorageKey.ProcoreMFEOverrides]: {
        storage: localStorage,
    },
    [StorageKey.MiniMap]: {
        storage: localStorage,
    },
    [StorageKey.NavigationCube]: {
        storage: localStorage,
    },
    [StorageKey.Joysticks]: {
        storage: localStorage,
    },
    [StorageKey.UpdateHomeView]: {
        storage: localStorage,
    },
    [StorageKey.AntiAliasing]: {
        storage: localStorage,
    },
    [StorageKey.Environment]: {
        storage: localStorage,
    },
    [StorageKey.FramerateTarget]: {
        storage: localStorage,
    },
    [StorageKey.PreRefreshState]: {
        storage: sessionStorage,
    },
    [StorageKey.IncrementalOfflineLimit]: {
        storage: localStorage,
    },
};
